import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {map} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ConfigService, DcpLoggingService} from '@dcp/configurator';
import {fromEvent} from 'rxjs';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';

declare global {
  interface Window {
    uidBaselineSettings: any;
    baseline: {
      signOutCallback: () => void;
      signOut: () => void;
      signInCallback: () => void;
      signIn: () => void;
    };
  }
}

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpBaselineAuthService {

  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    protected authService: DcpAuthService,
    protected loggingService: DcpLoggingService,
    protected configService: ConfigService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      window.uidBaselineSettings = this.configService.getObject('baselineUid');
      fromEvent(window, 'validUidSession').pipe(untilDestroyed(this)).subscribe((event) => this.onStartUidSession(event));
      fromEvent(window, 'startUidSession').pipe(untilDestroyed(this)).subscribe((event) => this.onStartUidSession(event));
    }
  }

  login() {
    return this.authService.isUserLoggedIn()
      .pipe(untilDestroyed(this),
        map((isUserLoggedIn) => {
            if (!isUserLoggedIn) {
              this.authService.login();
            }
          }
        ));
  }

  logout() {
    if (isPlatformBrowser(this.platformId)) {
      this.authService.coreLogout().then(() => window.baseline?.signOut());
    }
  }

  onStartUidSession(event: Event): void {
    this.login().pipe(untilDestroyed(this)).subscribe();
  }
}
